// components/Locale/IntlMessages.tsx
import React from "react";
import { useTranslation } from "react-i18next";

interface IntlMessagesProps {
    id: string;        // key dịch
    text?: string;     // fallback text nếu không có bản dịch
    values?: Record<string, any>; // optional cho interpolate
}

const IntlMessages: React.FC<IntlMessagesProps> = ({ id, text, values }) => {
    const { t } = useTranslation();
    return <>{t(id, { defaultValue: text, ...values })}</>;
};

export default IntlMessages;